'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var dependencyStack = [];
var dependencyRejectors = [];

function cleanDependencyStack() {
    dependencyRejectors.forEach(function (reject) {
        reject('stopped');
    });
    dependencyRejectors = [];
    dependencyStack = [];
}

var loadDepStack = function loadDepStack() {
    return new Promise(function (resolveStack, rejectStack) {
        if (dependencyStack.length) {
            var len = dependencyStack.length;
            Promise.all(dependencyStack).then(function () {
                if (len != dependencyStack.length) {
                    loadDepStack().then(resolveStack).catch(rejectStack);
                } else {
                    resolveStack();
                }
            }).catch(rejectStack);
        } else {
            resolveStack();
        }
    });
};

function loadDependencies(dependencies, modules) {
    var _loadDependencies = new Promise(function (loadResolve, loadReject) {
        dependencyRejectors.push(loadReject);

        var _loop = function _loop(key) {
            dependencies[key]().then(function (loadedModule) {
                modules[key] = loadedModule;
                if (Object.keys(modules).length === Object.keys(dependencies).length) loadResolve(modules);
            }).catch(loadReject);
        };

        for (var key in dependencies) {
            _loop(key);
        }
    });

    dependencyStack.push(_loadDependencies);
};

exports.loadDependencies = loadDependencies;
exports.cleanDependencyStack = cleanDependencyStack;
exports.loadDepStack = loadDepStack;
//# sourceMappingURL=dependency.js.map


//////////////////
// WEBPACK FOOTER
// ./~/perx-uikit/dist/helpers/dependency.js
// module id = 1280
// module chunks = 5